export const DecLineChart = ({
  strokeColor = "var(--color-red)",
  ...props
}: any) => (
  <svg width="81" height="39" viewBox="0 0 81 39" fill="none">
    <path
      d="M80 37.7259C69.0822 37.9256 64.8225 18.5965 53.9056 18.2602C42.5171 17.9093 37.8044 40.7389 26.5209 37.7259C13.5375 34.2591 14.0776 2.66986 1 1"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export const IncLineChart = ({
  strokeColor = "var(--color-green)",
  ...props
}: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={81}
    height={39}
    fill="none"
    {...props}
  >
    <path
      stroke={strokeColor}
      strokeLinejoin="round"
      strokeWidth={2}
      d="M1 37.726c10.918.2 15.177-19.13 26.094-19.466 11.389-.35 16.102 22.479 27.385 19.466C67.463 34.259 66.922 2.67 80 1"
    />
  </svg>
);

export const NoChange = ({
  strokeColor = "var(--color-yellow)",
  ...props
}: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={79}
    height={2}
    fill="none"
    {...props}
  >
    <path
      stroke={strokeColor}
      strokeLinejoin="round"
      strokeWidth={2}
      d="M79 1H.001"
    />
  </svg>
);
